import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import BatchesListPage from '../../../pages/batches/batches-list-page';
import { getTabFilterFromPathName } from '../../../services/batch-grid-service';

const mapStateToProps = (state) => {
  const selectedTab = getTabFilterFromPathName();
  const isLoading = Global.selectBatchesIsLoading(state);
  const batches = Global.selectBatchesBatchRows(state) || [];
  const showPlaceholder = batches.length === 0 && !isLoading;
  const users = Global.selectSellerUsers(state);
  const currentUserId = Global.selectUserCurrentUserId(state);
  const selectedUser = users.find((user) => user.userId === currentUserId);

  return {
    isLoading,
    selectedTab,
    selectedUser,
    showPlaceholder,
  };
};

export const BatchesListPageContainer = connect(mapStateToProps)(BatchesListPage);
